import { Component, OnInit } from '@angular/core';
import { ProcedureService } from '@services';
import Chart from 'chart.js/auto';

import {DashboardService} from "../../../../core/services/dashboard.service";

@Component({
  selector: 'app-reports-dashboard',
  templateUrl: './reports-dashboard.component.html',
  styleUrls: ['./reports-dashboard.component.scss'],
})
export class ReportsDashboardComponent implements OnInit {
  generalArray: any[] = [];
  totalArray: any[] = [];
  chart: any;
  title_one: string = '';
  numberone: number = 0;
  title_dos: string = '';
  numberdos: number = 0;
  title_tres: string = '';
  numbertres: number = 0;
  title_cuatro: string = '';
  numbercuatro: number = 0;

  title_cinco: string = '';
  numbercinco: number = 0;
  title_seis: string = '';
  numberseis: number = 0;
  title_siete: string = '';
  numbersiete: number = 0;
  title_ocho: string = '';
  numberocho: number = 0;
  title_nueve: string = '';
  numbernueve: number = 0;
  title_diez: string = '';
  numberdiez: number = 0;
  title_once: string = '';
  numberonce: number = 0;
  title_doce: string = '';
  numberdoce: number = 0;
  title_trece: string = '';
  numbertrece: number = 0;
  title_catorce: string = '';
  numbercatorce: number = 0;
  title_quince: string = '';
  numberquience: number = 0;
  title_dieciseis: string = '';
  numberdieciseis: number = 0;
  title_diecisiete: string = '';
  numberdiecisiete: number = 0;
  constructor(private procedureService: ProcedureService,
              private dashboardService: DashboardService) {}

  ngOnInit(): void {
    this.getCardInfo();
    this.getTableTotal();
  }

  getCardInfo() {
    this.dashboardService.getTitleCardsD().subscribe((values) => {
      this.generalArray = values;
      console.log("lista array", this.generalArray)
      this.title_one = this.generalArray[0]['description'];
      this.numberone = this.generalArray[0]['amount'];
      this.title_dos = this.generalArray[1]['description'];
      this.numberdos = this.generalArray[1]['amount'];
      this.title_tres = this.generalArray[2]['description'];
      this.numbertres = this.generalArray[2]['amount'];
      this.title_cuatro = this.generalArray[3]['description'];
      this.numbercuatro = this.generalArray[3]['amount'];

    });
  }

  getTableTotal() {
    this.dashboardService.getAmount().subscribe((values) => {
      this.totalArray = values;
      console.log("estados", this.totalArray)
      this.title_cinco = this.totalArray[0]['description'];
      this.numbercinco = this.totalArray[0]['amount'];
      this.title_seis = this.totalArray[1]['description'];
      this.numberseis = this.totalArray[1]['amount'];
      this.title_siete = this.totalArray[2]['description'];
      this.numbersiete = this.totalArray[2]['amount'];
      this.title_ocho = this.totalArray[3]['description'];
      this.numberocho = this.totalArray[3]['amount'];
      this.title_nueve = this.totalArray[4]['description'];
      this.numbernueve = this.totalArray[4]['amount'];
      this.title_diez = this.totalArray[5]['description'];
      this.numberdiez = this.totalArray[5]['amount'];
      this.title_once = this.totalArray[6]['description'];
      this.numberonce = this.totalArray[6]['amount'];
      this.title_doce = this.totalArray[7]['description'];
      this.numberdoce = this.totalArray[7]['amount'];
      this.title_trece = this.totalArray[8]['description'];
      this.numbertrece = this.totalArray[8]['amount'];
      this.title_catorce = this.totalArray[9]['description'];
      this.numbercatorce = this.totalArray[9]['amount'];
      this.title_quince= this.totalArray[10]['description'];
      this.numberquience= this.totalArray[10]['amount'];
      this.title_dieciseis= this.totalArray[11]['description'];
      this.numberdieciseis= this.totalArray[11]['amount'];
      console.log("nombre", this.title_quince)
      let myChart1 = new Chart('myChart', {
        type: 'bar',

        data: {
          labels: [
            'Total Global Trámites'
          ],
          datasets: [
            {
              label: this.title_cinco,
              data: [this.numbercinco],
              backgroundColor: '#EC1919',
              borderColor: '#EC1919',
              borderWidth: 1,
            },
            {
              label: this.title_seis,
              data: [this.numberseis],
              backgroundColor: '#1111EE',
              borderColor: '#1111EE',
              borderWidth: 1,
            },
            {
              label: this.title_siete,
              data: [this.numbersiete],
              backgroundColor: '#EE7C11',
              borderColor: '#EE7C11',
              borderWidth: 1,
            },
            {
              label: this.title_ocho,
              data: [this.numberocho],
              backgroundColor: '#14D131',
              borderColor: '#14D131',
              borderWidth: 1,
            },
            {
              label: this.title_nueve,
              data: [this.numbernueve],
              backgroundColor: '#D114AC',
              borderColor: '#D114AC',
              borderWidth: 1,
            },
            {
              label: this.title_diez,
              data: [this.numberdiez],
              backgroundColor: '#F2FF2E',
              borderColor: '#F2FF2E',
              borderWidth: 1,
            },
            {
              label: this.title_once,
              data: [this.numberonce],
              backgroundColor: '#2EFF71',
              borderColor: '#2EFF71',
              borderWidth: 1,
            },

            {
              label: this.title_doce,
              data: [this.numberdoce],
              backgroundColor: '#EA2C77',
              borderColor: '#EA2C77',
              borderWidth: 1,
            },
            {
              label: this.title_trece,
              data: [this.numbertrece],
              backgroundColor: '#83870C',
              borderColor: '#83870C',
              borderWidth: 1,
            },
            {
              label: this.title_catorce,
              data: [this.numbercatorce],
              backgroundColor: '#83870C',
              borderColor: '#83870C',
              borderWidth: 1,
            },
            {
              label: this.title_quince,
              data: [this.numberquience],
              backgroundColor: '#0C8767',
              borderColor: '#0C8767',
              borderWidth: 1,
            },
            {
              label: this.title_dieciseis,
              data: [this.numberdieciseis],
              backgroundColor: '#FFAF00',
              borderColor: '#FFAF00',
              borderWidth: 1,
            }
          ],
        },
        options: {
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
      });

      let myChart2 = new Chart('myChartDount', {
        type: 'doughnut',

        data: {

          labels: [this.title_tres, this.title_cuatro],
          datasets: [{
            data: [this.numbertres,this.numbercuatro],
            backgroundColor: ["#0196FD","#FFAF00"],
            borderWidth: 1,
          }]
        },
        options: {
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
      });
      console.log(myChart1,myChart2);

    });
  }
}
